import { render, staticRenderFns } from "./RsaSchedaOspiteUsciteEditComponent.vue?vue&type=template&id=a12fa80a"
import script from "./RsaSchedaOspiteUsciteEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaOspiteUsciteEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports